import MainLayout from "../layout/MainLayout";
import {
  ToggleButton,
  Select,
  Button2,
  QuickActionSelect,
} from "../Components/index";
import plusIcon from "../assets/icons/plus.png";
import ExistingRecipient from "../Components/sendMoney/ExistingRecipient";
import SomeoneNew from "../Components/sendMoney/SomeoneNew";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccounts } from "../data/live";

const last4 = (s) => (s ? String(s).slice(-4) : "0000");

const NewTransfer = ({
  initialTab = "Existing Recipient",
  someoneNewInitialTab = "Email/Phone/Card",
}) => {
  const navigate = useNavigate();
  const { accounts, loading } = useAccounts();

  const [sourceAccountId, setSourceAccountId] = useState("");
  const [tab, setTab] = useState(initialTab);

  useEffect(() => {
    if (accounts.length > 0 && !sourceAccountId) {
      const def =
        accounts.find((a) => a.isDefault) ||
        accounts.find((a) => a.currency === "AUD") ||
        accounts[0];
      setSourceAccountId(def.id);
    }
  }, [accounts, sourceAccountId]);

  const sourceAccount = accounts.find((a) => a.id === sourceAccountId);
  const accountOptions = accounts.map((a) => ({
    name: `${a.currency} • ****${last4(a.accountNumber || a.iban)}${
      a.isDefault ? " (Default)" : ""
    }`,
    value: a.id,
  }));

  const availableBalance = sourceAccount
    ? `${Number(sourceAccount.availableBalance).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${sourceAccount.currency}`
    : "0.00";

  return (
    <MainLayout
      NavName="New Transfer"
      expand={false}
      pageClassName="dashboard-page new-transfer-page"
      contentClassName="dashboard-content"
    >
      <div className="new-transfer-shell">
        <div className="new-transfer-toolbar d-flex flex-column gap-3">
          <div className="row">
            <div className="col-12 col-md-5 col-lg-4">
              <Select
                value={sourceAccountId}
                onChange={(e) => setSourceAccountId(e.target.value)}
                options={accountOptions}
                defaultValue={
                  loading ? "Loading accounts..." : "Select account"
                }
                selectStyle={{ width: "100%" }}
                className="bg-light rounded-5"
                popupClassName="bg-White"
              />
            </div>
          </div>
          <div className="d-flex justify-content-md-between gap-2 flex-wrap justify-content-center">
            <ToggleButton
              options={["Existing Recipient", "Someone New"]}
              defaultValue={tab}
              onChange={(value) => setTab(value)}
            />

            <div className="d-flex gap-3 align-items-center flex-wrap flex-md-nowrap justify-content-center justify-content-md-end">
              <p className="p-0 m-0 fs14px">
                Available balance:{" "}
                <span
                  className="fs-6 fw-medium"
                  style={{ color: "#1bbb6b" }}
                >
                  {availableBalance}
                </span>
              </p>

              <Button2
                buttonName={"Add Funds"}
                className={"btn-outline-success"}
                divClassName={"gap-1"}
                icon={<img src={plusIcon} alt="add" />}
                onClick={() => navigate("/add-funds")}
              />
              <QuickActionSelect />
            </div>
          </div>
        </div>

        {tab === "Existing Recipient" ? (
          <ExistingRecipient
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
            onSourceAccountChange={setSourceAccountId}
          />
        ) : (
          <SomeoneNew
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
            initialTab={someoneNewInitialTab}
          />
        )}
      </div>
    </MainLayout>
  );
};

export default NewTransfer;
